import { useSelector } from 'react-redux';
import { selectUserInfoData } from '../../../reducers/userInfoReducer';
import { selectConnectedCrmOrgs } from '../../pages/environments/environmentsReducer';
import { usePermissions } from './usePermissions';

/**
 * Checks if the user is allowed to deploy or request changes to at least one connected org.
 * @returns `true` if the user has deploy permissions for at least one org, `false` otherwise.
 */
export const useCanDeployOrRequestToAnyOrg = () => {
  const { hasAnyPermissions } = usePermissions();
  const userInfo = useSelector(selectUserInfoData);
  const connectedOrgs = useSelector(selectConnectedCrmOrgs);

  const canDeployOrRequestToAnyOrg = () => {
    if (!userInfo?.orgPermissions || connectedOrgs.length === 0) {
      return false;
    }

    return connectedOrgs.some((org) =>
      hasAnyPermissions(['create:deploy-job', 'create:request-changes'], org.id),
    );
  };

  return { canDeployOrRequestToAnyOrg };
};
